import { render } from "./ExamQuestion.vue?vue&type=template&id=320dda80&ts=true"
import script from "./ExamQuestion.vue?vue&type=script&lang=ts"
export * from "./ExamQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__